module.exports = __webpack_public_path__ + "img/fill-blank-4.6b4cd3dc.jpg";